import { authAPI } from "../api/auth";
import { useLatestQuery } from "../api/useLatestQuery";

export const useWhoAmI = () => {
  const { data: whoAmI, isFetched } = useLatestQuery(["authAPI.whoAmI"], () =>
    authAPI.whoAmI({})
  );

  const whoAmIReady = isFetched;
  const confirmedNotLoggedIn = whoAmIReady && !!whoAmI?.ok && !whoAmI.id;
  const confirmedLoggedIn = whoAmIReady && !!whoAmI?.ok && !!whoAmI.id;
  const concernId = whoAmI?.concernId;

  if (concernId && window.cvpIdConcern !== concernId) {
    throw new Error("concernId mismatch");
  }

  const isProduction = whoAmI.environment.toLowerCase() === "production";

  const confirmedNoProfileInConcern =
    whoAmIReady &&
    !!whoAmI?.ok &&
    !!whoAmI.concernId &&
    !whoAmI.hasProfileInConcern;

  const confirmedHasProfileInConcern =
    whoAmIReady &&
    !!whoAmI?.ok &&
    !!whoAmI.id &&
    !!whoAmI.concernId &&
    !!whoAmI.hasProfileInConcern;

  return {
    whoAmI,
    isFetched,
    concernId,

    /** Api call is done, and we know we are logged in with visma connect */
    confirmedLoggedIn,

    /** Api call is done, and we know we are not logged in with visma connect*/
    confirmedNotLoggedIn,

    /**
     * Api call is done, we have a concern, and preciely one of these two are true:
     * 1. User is not logged in with visma connect
     * 2. User is logged in with visma connect, but has no profile in the concern
     */
    confirmedNoProfileInConcern,

    /** Api call is done, user is logged in, we have a concern and the user has a profile in that concern */
    confirmedHasProfileInConcern,
    isProduction,
  };
};
